<template>
  <div id="spa-view">
    <router-view />
    <icons></icons>
  </div>
</template>

<script>
  import Icons from './components/shared/Icons'

  export default {
    name: 'app',

    components: {
      Icons
    }
  }
</script>
